<template>
  <div :class="{ 'app-wrapper': true, ai_stick_bg: !APP_IN_BROWSER }">
    <div id="app">
      <router-view />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Base64 from "@/utils/base64";
import Cookie from "js-cookie";
export default {
  name: "App",
  data() {
    return {
      APP_IN_BROWSER: !window.pcmjssdk,
    };
  },
  computed: {
    ...mapState({
      notifyActionType: (state) => state.notifyActionType,
      notifyActionContent: (state) => state.notifyActionContent,
      notifyActionFrom: (state) => state.notifyActionFrom,
      notifyActionTargetLanguage: (state) => state.notifyActionTargetLanguage,
    }),
  },
  async created() {
    /**
     * 模拟划词通知
     * type：提问 ask、搜索 search、翻译 translate、润色 polish、续写 continue、总结 summarize、红点 badge、打开指定选项卡（小游戏） open_tab


      //  总结
      window.$handleNotify('chat', {
          type: 'summarize',
          from: 3,
          content: '4月7日消息，Meta上周发布的新旗舰AI模型Llama 4 Maverick在LM Arena测试中获第二名，成绩遭质疑。多位AI研究人员指出，测试版本与给开发者的版本不一致，测试版是针对对话性优化的，以适应测试环境。因LM Arena可靠性存争议，以往公司鲜少这么做。这一行为给开发者带来困扰，且具误导性，已有研究人员发现两个版本行为有差异，而Meta及相关组织暂未回应 。',
      })

      //  提问
      window.$handleNotify('chat', {
          type: 'ask',
          from: 3,
          content: '如何提升睡眠质量？',
      })

      //  翻译（2.4 之前版本，使用问答翻译）
      window.$handleNotify('chat', {
          type: 'translate',
          from: 3,
          content: 'Best wishes for the New Year The old year is renewed in the change of the four seasons, and the New Year is restarted in the scheduled fireworks.',
      })

      // AI 翻译
      window.$handleNotify('translate', {
        type: 'translate',
        from: 3,
        content:
          'Best wishes for the New Year The old year is renewed in the change of the four seasons, and the New Year is restarted in the scheduled fireworks.',
        targetLanguage: '中文（简体）', // 目标语言：'中文（简体）', '中文（繁体）', '英文'
      })

      // 打开小游戏指定 tab 页
      window.$handleNotify('game', {
        type: 'open_tab',
        from: 3, // 右下角弹窗：2；侧栏弹泡：3；划词：5
        content: '飞行射击',
      })

      // 小游戏红点
      window.$handleNotify('game', {
        type: 'badge',
        content: '飞行射击',
      })

     */
    window.$handleNotify = async (page, data) => {
      const params = Base64.encode(
        JSON.stringify(data),
      )
      const res = await window.pcmjssdk.asyncBrowerQuery(
        'NotifyAIStick',
        `--action=open_tab --target=${page} --tab-params=${params}`,
      )
      console.log('res', res)
    }

    console.log(123456, this.$store.state.aisearch.intoHistory);
    window.jsbridge?.registerNativeNotify("", (category, content) => {
      console.log("NEWPLUGIN_WRAPPLUGIN Notify:", category, content);
      if (category == "NEWPLUGIN_WRAPPLUGIN_LOGINSTATUSCHANGE") {
        const notifyInfo = JSON.parse(content);
        this.loginChangeCallback(notifyInfo);
      } else if (category == "FRAMEWORK_ONSHOWWINDOW") {
        // const notifyInfo = JSON.parse(content);
        // 页面获得焦点通知
        console.log(typeof content, "NEWPLUGIN_WRAPPLUGIN Notify:content");
        this.handleFocus(content);
      }
      if (category == "FRAMEWORK_ONSHOWWINDOW") {
        this.$store.commit("updataAiWindowStatus", content === "1");
      }
      if (category == "FRAMEWORK_NOTIFY_EXECUTE_CMD_FROM_LOCAL_APPLICATION") {
        // 划词 && 写作页新手引导完成后触发到写作结果
        this.$store.commit("updateNotifyActionType", "");
        this.$store.commit("updateNotifyActionContent", "");
        this.$store.commit("updateNotifyActionFrom", "");
        this.$store.commit("updateNotifyActionTargetLanguage", "");
        try {
          const result = JSON.parse(Base64.decode(content));
          console.warn("划词内容", result);
          setTimeout(() => {
            this.$store.commit("updateNotifyActionType", result?.type);
            this.$store.commit(
              "updateNotifyActionContent",
              result?.content?.slice(0, 2000)
            );
            this.$store.commit("updateNotifyActionFrom", result?.from);
            this.$store.commit("updateNotifyActionTargetLanguage", result?.targetLanguage);
          });
        } catch (error) {
          console.log(error);
        }
      }
      if (category === "FRAMEWORK_NOTIFY_AISTICK_REMOVE_CUSTOM_APP") {
        // 移除自定义应用
        this.$store.commit("setRemoveCustomApp", "");
        setTimeout(() => {
          this.$store.commit("setRemoveCustomApp", content);
        });
      }
    });

    try {
      window.SLBSDK?.addListener("LIDNotify", (content) => {
        this.loginChangeCallback(content);
      });
      // 进来把登录信息放store里面
      let loginInfo = window.pcmjssdk
        ? await window.pcmjssdk.commonMethod.getLoginInfo()
        : await window.SLBSDK.nativeCall("SLGetLoginStatus");
      console.log(loginInfo, "loginInfo");
      loginInfo =
        typeof loginInfo === "object" ? loginInfo : JSON.parse(loginInfo);
      this.$store.commit("setLoginInfo", loginInfo);
    } catch (error) {
      console.log(error);
    }

    // AI Stick 版本
    try {
      window.pcmjssdk
        ?.asyncBrowerQuery("GetAiStickVersion")
        .then((res) => {
          if (res) {
            this.$store.commit("setAiStickVersion", res);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  },
  async mounted() {
    try {
      // 通知端上资源加载完成
      const loadRes = await window.pcmjssdk?.asyncBrowerQuery('AiStickPageLoaded')
      console.warn('AiStickPageLoaded Success', loadRes)
      if (document.getElementById('app-loading')) {
        document.getElementById('app-loading').style.display = 'none'
      }
    } catch (error) {
      console.warn('AiStickPageLoaded Error', error)
      if (document.getElementById('app-loading')) {
        document.getElementById('app-loading').style.display = 'none'
      }
    }
  },
  methods: {
    handleFocus(focusState) {
      // ai搜索
      this.$store.commit("setPageFocusState", Number(focusState));
    },
    loginChangeCallback(notifyInfo) {
      console.log("登录状态变更----", notifyInfo);
      if (notifyInfo.loginstatus === 1 || notifyInfo.code === 1) {
        //登录成功
        // loginId? userId?
        Cookie.set("realm", notifyInfo.realm);
        Cookie.set("token", notifyInfo.token);
        this.$store.commit("setLoginInfo", notifyInfo);
        //判断进入历史记录页面是否需要登录
        if (this.$store.state.aisearch.intoHistory) {
          this.$router.push({ name: "ai_search_history" });
          this.$store.commit("setIntoHistroy", false);
        }

        if (this.notifyActionType && this.notifyActionContent) {
          // 登录成功，重新设置划词内容，调起聊天
          const notifyActionType = this.notifyActionType;
          const notifyActionContent = this.notifyActionContent;
          const notifyActionFrom = this.notifyActionFrom;
          const notifyActionTargetLanguage = this.notifyActionTargetLanguage;
          this.$store.commit("updateNotifyActionType", "");
          this.$store.commit("updateNotifyActionContent", "");
          this.$store.commit("updateNotifyActionFrom", "");
          this.$store.commit("updateNotifyActionTargetLanguage", "");
          setTimeout(() => {
            this.$store.commit("updateNotifyActionType", notifyActionType);
            this.$store.commit(
              "updateNotifyActionContent",
              notifyActionContent
            );
            this.$store.commit("updateNotifyActionFrom", notifyActionFrom);
            this.$store.commit("updateNotifyActionTargetLanguage", notifyActionTargetLanguage);
          });
        }
      } else {
        console.log("登录状态为否。清空cookie，");
        Cookie.set("slbrowser_pc_ai_assist_authorization", "");
        this.$store.commit("setLoginInfo", notifyInfo);
        if (window.pcmjssdk) {
          this.$store.commit("setCurrentSearchCode", null);
        }
      }
    },
  },
};
</script>
<style lang="scss">
// 全局样式,游戏盒子在用，其他页面 视情况而定
#app {
  height: 100%;
  width: 100%;
}

html,
body,
.app-wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

body {
  ::-webkit-scrollbar {
    width: 14px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent;
    background-clip: padding-box;
    border: 4px solid transparent;
    background-clip: padding-box;
    border-radius: 12px;
  }

  :hover {
    &::-webkit-scrollbar-thumb {
      border: 4px solid transparent;
      background-color: rgba($color: #4e4b69, $alpha: 0.15);

      &:hover {
        border: 3px solid transparent;
        background-color: rgba($color: #4e4b69, $alpha: 0.2);
      }
    }
  }
}

body {
  .common-scrollbar {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: auto;
    overflow-x: hidden;
  }

  .responsive-layout {
    width: 100%;
    margin: 0 auto;

    @media screen and (max-width: 950px) {
      max-width: min(calc(100% - 40px), 880px);
    }

    @media screen and (min-width: 950px) {
      max-width: min(880px, calc(100% - 160px));
    }
  }
}

.answer-result-tip {
  font-family: HYQiHei;
  font-size: 12px;
  line-height: 21px;
  position: fixed;
  z-index: 9999;
  max-width: 200px;
  padding: 10px 18px;
  cursor: pointer;
  text-align: justify;
  opacity: 0;
  color: #4e4b69;
  border-radius: 8px;
  background: rgba(254, 254, 254);
  backdrop-filter: blur(1px);
  &:hover {
    text-decoration: underline;
  }
}

.custom-contextmenu {
  font-size: 14px;
  position: fixed;
  z-index: 99999;
  width: max-content;
  padding: 6px;
  color: #4e4b69;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);

  .contextmenu-item {
    position: relative;
    align-items: center;
    padding: 10px 12px 10px 30px;
    cursor: pointer;
    transition: all 0.2s;
    border-radius: 6px;

    &:hover {
      background-color: #f5f6fa;
    }

    &::before {
      position: absolute;
      top: 50%;
      left: 8px;
      width: 18px;
      height: 18px;
      content: "";
      transform: translateY(-50%);
      background-color: #615e83;
      background-size: cover;
      mask-size: 100%;
      mask-position: center center;
    }

    &.copy {
      &::before {
        mask-image: url(@/assets/images/common/copy.svg);
      }
    }

    &.search {
      &::before {
        mask-image: url(@/assets/images/common/search.svg);
      }
    }
  }
}

.actions-btns {
  display: flex;
  align-items: center;
  user-select: none;
  flex-flow: wrap;

  .page {
    display: flex;
  }

  .btn-item {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 12px 0 0;

    .sp {
      font-size: 12px;
      cursor: pointer;
      color: #615e83;

      &.tip {
        font-size: 12px;
        line-height: 18px;
        position: absolute;
        bottom: 26px;
        left: 50%;
        visibility: hidden;
        padding: 4px 8px;
        transition: all 0.2s;
        transform: translateX(-50%);
        white-space: nowrap;
        opacity: 0;
        color: #ffffff;
        border-radius: 5px;
        background-color: #333333;
        width: max-content;

        &::before {
          position: absolute;
          bottom: -8px;
          left: 50%;
          content: "";
          width: 14px;
          height: 14px;
          background-image: url(@/assets/images/tip-icon.svg);
          background-position: center;
          transform: translateX(-50%);
          background-repeat: no-repeat;
        }
      }

      &.icon {
        position: relative;
        width: 18px;
        height: 18px;
        background-color: #615e83;
        mask-size: 100%;
        mask-position: center center;
        flex: 0 0 auto;

        &.again {
          mask-image: url(@/assets/images/article/again.png);
        }

        &.copy {
          mask-image: url(@/assets/images/article/copy.png);
          &.active {
            mask-image: url(@/assets/images/article/checked.png);
          }
        }

        &.share {
          mask-image: url(@/assets/images/article/share.png);
        }

        &.prev {
          mask-image: url(@/assets/images/article/arrow.png);
        }

        &.next {
          transform: rotate(180deg);
          mask-image: url(@/assets/images/article/arrow.png);
        }

        &.like {
          mask-image: url(@/assets/images/article/like.png);

          &.active {
            mask-image: url(@/assets/images/article/like-active.png);
          }
        }

        &.unlike {
          transform: rotate(180deg);
          mask-image: url(@/assets/images/article/like.png);

          &.active {
            mask-image: url(@/assets/images/article/like-active.png);
          }
        }

        &.disabled {
          cursor: not-allowed;
          pointer-events: none;
          opacity: 0.6;
        }
      }
    }

    &:hover {
      .tip {
        visibility: visible;
        opacity: 1;
      }

      .sp:not(.tip) {
        color: #4e4b69;

        &.icon {
          background-color: #4e4b69;
        }
      }
    }

    &.disabled {
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.6;
    }
  }
}

.common-result-font {
  font-size: 16px;
  line-height: 26px;
  color: #4e4b69;

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  div,
  dl,
  dt,
  dd,
  table,
  ul,
  ol,
  li,
  p,
  blockquote,
  pre,
  hr,
  form,
  fieldset,
  legend,
  input,
  button,
  textarea,
  menu {
    margin-bottom: 16px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 1em;
    line-height: initial;
  }

  table {
    overflow: hidden;
    border-collapse: separate;
    border: 1px solid rgb(97,94,131,0.1);
    border-radius: 12px;
  }

  thead {
    background-color: rgb(97,94,131,0.05);

    th {
      font-weight: 700;
      padding: 12px 16px;
      border: 1px solid rgb(97,94,131,0.1);
      border-top: none;
      border-left: none;

      &:last-child {
        border-right: none;
      }
    }
  }

  tbody {
    background-color: rgba(255, 255, 255, 0.4);

    td {
      padding: 12px 16px;
      border: 1px solid rgb(97,94,131,0.1);
      border-top: none;
      border-left: none;

      &:last-child {
        border-right: none;
      }
    }

    tr {
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }

  hr {
    height: 0;
    margin: 20px 0;
    border: none;
    border-bottom: 1px solid rgb(97,94,131,0.1);
  }

  img {
    display: block;
    max-width: 100%;
    cursor: pointer;
    border-radius: 16px;
    border: 0.5px solid rgba(0, 0, 0, 0.16);
    margin: 16px 0;
    max-height: 340px;
    box-sizing: border-box;
  }

  blockquote {
    display: block;
    border-radius: 16px;

    p {
      padding-left: 12px;
      color: #8895b3;
      border-left: 3px solid rgb(0, 0, 0, 0.1);
    }
  }

  code {
    padding: 3px 5px;
  }

  pre {
    overflow: hidden;
    margin-bottom: 20px;
    border-radius: 12px;

    code {
      font-family: Menlo, Monaco, Consolas, Courier New, monospace;
      padding: 16px;
    }

    .code-block-header {
      font-family: "Source Code Pro";
      font-size: 18px;
      font-weight: 500;
      line-height: normal;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0 !important;
      padding: 12px 16px;
      color: rgba(255, 255, 255, 0.8);

      background: #313641;

      .code-block-header__lang {
        font-size: 16px;
      }

      .code-copy-btn {
        font-size: 14px;
        display: flex;
        align-items: center;
        color: #d6d7d9;
        background: none;
        margin-bottom: 0;
        &:hover {
          color: #ffffff;
        }

        i {
          font-size: 20px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  span.cursor-blink {
    display: inline !important;
    animation: 0.8s cursorBlink infinite;
  }

  .katex-display {
    overflow-x: auto;
    overflow-y: hidden;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-weight: normal;
    font-style: italic;
  }

  del,
  s {
    text-decoration: line-through;
  }

  @keyframes cursorBlink {
    from {
      opacity: 0;
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .code-block-body::-webkit-scrollbar,
  .katex-display::-webkit-scrollbar,
  table::-webkit-scrollbar {
    height: 6px;
  }

  .code-block-body::-webkit-scrollbar-track,
  .katex-display::-webkit-scrollbar-track,
  table::-webkit-scrollbar-track {
    background-color: transparent;
  }

  .code-block-body::-webkit-scrollbar-thumb,
  .katex-display::-webkit-scrollbar-thumb,
  table::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background: #e4e4e4;
  }

  .code-block-body::-webkit-scrollbar-thumb:hover,
  .katex-display::-webkit-scrollbar-thumb:hover,
  table::-webkit-scrollbar-thumb:hover {
    cursor: pointer;
    background: #999999;
  }
}
.ai_stick_bg {
  box-sizing: border-box;
  background: url(@/assets/images/ai_chat/ai_stick_bg.png);
  background-size: 100% 100%;
  background-repeat: repeat-x;
  background-position: center;
}
</style>
